import React from 'react';
import {useNavigate} from "react-router-dom";
import ListProxyPage from "./ListProxyPage";

const ListServiceProxyPage = () => {
    const navigate = useNavigate();

    let redirectChangeUser = (listId) => {
        navigate('/admin/proxy/chuyen-khach-hang.html?' + listId);
    }
    return <ListProxyPage
        redirectChangeUser={ (listId) => redirectChangeUser(listId) }
    />

}

export default ListServiceProxyPage;